import type { FormDSL } from '@commenda/types';
import { walkComponents } from '../dsl-traversal';

/**
 * Represents a DirectorDocument component's data for submit handling.
 * These are submitted via the Person API, not the DSL.
 */
export interface DirectorDocumentMapping {
  fieldId: string;
  documentKind: string;
}

/**
 * Extract DirectorDocument component mappings. These are submitted via the
 * Person API, not the DSL, so they're tracked separately.
 */
export function extractDirectorDocumentMappings(
  dsl: FormDSL
): DirectorDocumentMapping[] {
  const mappings: DirectorDocumentMapping[] = [];
  walkComponents(dsl, (component) => {
    if (component.component === 'DirectorDocument' && component.fieldId) {
      const props = component.props as
        | { documentKind?: string | null }
        | undefined;
      if (props?.documentKind) {
        mappings.push({
          fieldId: component.fieldId,
          documentKind: props.documentKind,
        });
      }
    }
  });
  return mappings;
}
